/*!
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.5.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { CoreUtils } from '@microsoft/applicationinsights-core-js';
export { EventHelper } from '@microsoft/applicationinsights-core-js';
var stringUtils = /** @class */ (function () {
    function stringUtils() {
    }
    stringUtils.GetLength = function (strObject) {
        var res = 0;
        if (!CoreUtils.isNullOrUndefined(strObject)) {
            var stringified = "";
            try {
                stringified = strObject.toString();
            }
            catch (ex) {
                // some troubles with complex object
            }
            res = stringified.length;
            res = isNaN(res) ? 0 : res;
        }
        return res;
    };
    return stringUtils;
}());
export { stringUtils };
//# sourceMappingURL=ajaxUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-esm/ajaxUtils.js
// module id = 818
// module chunks = 0